<template>
  <div ref="menuRef" class="flex h-full w-full items-center justify-end">
    <Button
      variant="ghost-no-padding"
      transition="transition-all"
      class="hover-lift-no-shadow"
      @click="toggleMenu"
    >
      <span class="text-right underline">
        {{ __('See all') }}
      </span>
    </Button>

    <transition
      enter-active-class="transition-all duration-150 ease-out"
      enter-from-class="opacity-0 scale-95"
      enter-to-class="opacity-100 scale-100"
      leave-active-class="transition-all duration-100 ease-in"
      leave-from-class="opacity-100 scale-100"
      leave-to-class="opacity-0 scale-95"
    >
      <div
        v-if="showMenu"
        class="hover-scale scrollbar-thin absolute bottom-[11%] right-24 z-50 mt-2 max-h-48 w-64 overflow-auto rounded-lg border bg-white shadow-lg sm:bottom-auto sm:top-[86%]"
      >
        <ul class="flex h-full w-full flex-col text-sm text-gray-700">
          <li v-for="collaborator in data" class="flex w-full">
            <div
              class="flex w-full cursor-default flex-row items-center justify-start gap-x-4 rounded p-4"
            >
              <img
                class="inline-block size-8 rounded-full ring-2 ring-white"
                :src="collaborator.profile_picture_url"
                alt=""
              />
              <span class="truncate text-sm">
                {{ collaborator.first_name + ' ' + collaborator.last_name }}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script setup>
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import { Button } from '../../../../../../components/block/button';

  import { __ } from '@/helpers';
  const showMenu = ref(false);
  const menuRef = ref(null);
  const toggleMenu = () => {
    showMenu.value = !showMenu.value;
  };
  const props = defineProps({
    data: Object
  });
  function handleClickOutside(event) {
    if (menuRef.value && !menuRef.value.contains(event.target)) {
      showMenu.value = false;
    }
  }

  onMounted(() => {
    document.addEventListener('click', handleClickOutside);
  });

  onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside);
  });
</script>
